export function Loading() {
	return <span className="icon-new icon-loading" />;
}

export default Loading;
